import gql from "graphql-tag";

export const ValidateUserToken = gql`
  query validateUserToken($token: String!) {
    validateUserToken(token: $token)
  }
`;
